import { Inject, Injectable } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { CookieService } from 'ngx-cookie-service'

@Injectable({
  providedIn: 'root',
})
export class GbCookieService {
  get accessTokenCookieName(): string {
    return this.appConfig.accessTokenCookieName
  }

  constructor(
    protected cookieService: CookieService,
    @Inject(APP_CONFIG) protected appConfig: any,
  ) {}

  setCookie(name: string, value: string, expires?: number | Date): void {
    this.cookieService.set(name, value, {
      expires,
      path: '/',
      secure: true,
      sameSite: 'Strict',
    })
  }

  getCookie(name: string): string {
    return this.cookieService.get(name)
  }

  getAccessToken(): string {
    return this.getCookie(this.accessTokenCookieName)
  }

  hasAccessToken(): boolean {
    return this.cookieService.check(this.accessTokenCookieName)
  }

  deleteCookie(name: string, path = '/'): void {
    this.cookieService.delete(name, path)
  }

  setAccessToken(token: string | undefined): void {
    if (token) {
      const now = new Date()
      const expires = new Date(now.setMonth(now.getMonth() + 1))
      const value = { $$_: token } // required to support tokens from old
      this.setCookie(this.accessTokenCookieName, JSON.stringify(value), expires)
    }
  }
}
